
const ProtocolCmd = require("./ProtocolCmd");

function CMiddleServer()
{
	let oMiddleServer = null;
	let onConnected = null;
	let onReconnected = null;
	let onDisconnected = null;
	let onReceive = null;
	let onHeartbeatTimeout = null;
	let mDeviceName = null;
	let mConnectionId = null;
	let mHeartbeatHdl = null;
	let mHeartbeatTimeout = null;
	let mHeartbeatNoAckCnt = 0;
	let mConnectTimeout = null;
	let mReconnectTimeout = null;
	let mIntervalSendCmd = null;
	let mRetryReconnectCntInMachine = 0;
	const mCmdQueue = [];
	const mHeartbeatData = {
		userInfo: null,
		roomId: null,
		machine: null
	};

	CMiddleServer.prototype.init = function (deviceName, fncOnConnected, fncOnReconnected, fncOnDisconnected, fncOnReceive, fncHeartbeatTimeout)
	{
		oMiddleServer = this;
		mDeviceName = deviceName;
		onConnected = fncOnConnected;
		onReconnected = fncOnReconnected
		onDisconnected = fncOnDisconnected;
		onReceive = fncOnReceive;
		onHeartbeatTimeout = fncHeartbeatTimeout;

		// for unknown reason, the webSocket seems not able to combine packet,
		// so if multi packets send at same time, only the first packet could be sent...
		// use queue to make sure all packets could be sent
		if (mIntervalSendCmd) clearInterval(mIntervalSendCmd);
		mIntervalSendCmd = setInterval(() => {
			const cmdData = mCmdQueue.shift();
			if (cmdData) {
				this.send(cmdData.cmd, cmdData.data)
			}
		}, 50);
	}

	CMiddleServer.prototype.start = function ()
	{
		console.log('CMiddleServer do start');
		if (mConnectTimeout) clearTimeout(mConnectTimeout);
		mConnectTimeout = setTimeout(function() {
			oMiddleServer.onDisconnected("連線逾時");
			// clear timeout
			clearTimeout(mConnectTimeout);
			mConnectTimeout = null;
		}, 3000);
	}

	CMiddleServer.prototype.reconnect = function (errMsg)
	{
		console.log('CMiddleServer do reconnect');
		if (mReconnectTimeout) clearTimeout(mReconnectTimeout);
		mReconnectTimeout = setTimeout(function() {
			if (mRetryReconnectCntInMachine >= 3) {
				mRetryReconnectCntInMachine = 0;
				oMiddleServer.onDisconnected(errMsg ? errMsg : "重新連線失敗");
			}
			else {
				mRetryReconnectCntInMachine++;
				oMiddleServer.reconnect(errMsg ? errMsg : `重新連線次數:${mRetryReconnectCntInMachine}`);
			}
			
			// clear timeout
			clearTimeout(mReconnectTimeout);
			mReconnectTimeout = null;
		}, 3000);
	}

	CMiddleServer.prototype.stop = function ()
	{
		console.log('CMiddleServer do stop');
		this.stopHeartbeat();
		if (mConnectTimeout) {
			clearTimeout(mConnectTimeout);
			mConnectTimeout = null;
		}
	}

	CMiddleServer.prototype.isConnected = function ()
	{
		return false;
	}

	CMiddleServer.prototype.startHeartbeat = function (data)
	{
		const heartbeatInterval = 5000;

		if (data.userInfo) mHeartbeatData.userInfo = data.userInfo;
		if (data.roomId) mHeartbeatData.roomId = data.roomId;
		if (data.machine) mHeartbeatData.machine = data.machine;
		
		if (mHeartbeatHdl) clearInterval(mHeartbeatHdl);
		mHeartbeatHdl = setInterval(function () {
			const obj = {
				account: mHeartbeatData.userInfo ? mHeartbeatData.userInfo.Account : null,
				roomId: mHeartbeatData.roomId,
				machine: mHeartbeatData.machine ? mHeartbeatData.machine.MachineName : null
			}
			oMiddleServer.invoke(ProtocolCmd.Heartbeat, JSON.stringify(obj));
			oMiddleServer.triggerHeartbeatAckTimeout(Math.floor(heartbeatInterval * 0.9));
		}, heartbeatInterval);
	}

	CMiddleServer.prototype.stopHeartbeat = function ()
	{
		if (mHeartbeatHdl) {
			clearInterval(mHeartbeatHdl);
			mHeartbeatHdl = null;
        }
	}

	CMiddleServer.prototype.triggerHeartbeatAckTimeout = function (ackTimeout)
	{
		// clear heartbeat ack timeout
		this.clearHeartbeatAckTimeout();
		// set new timeout for heartbeat ack
		mHeartbeatTimeout = setTimeout(function() {
			mHeartbeatTimeout = null;
			// check if no ack many times
			if (mHeartbeatNoAckCnt >= 5) {
				mHeartbeatNoAckCnt = 0;
				if (onHeartbeatTimeout) onHeartbeatTimeout();
			}
			else {
				mHeartbeatNoAckCnt++;
			}
		}, ackTimeout);
	}

	CMiddleServer.prototype.clearHeartbeatAckTimeout = function ()
	{
		// clear heartbeat ack timeout
		if (mHeartbeatTimeout) {
			clearTimeout(mHeartbeatTimeout);
			mHeartbeatTimeout = null;
		}
	}

	CMiddleServer.prototype.deviceName = function ()
	{
		return mDeviceName;
	}

	CMiddleServer.prototype.connectionId = function ()
	{
		return mConnectionId;
    }

	CMiddleServer.prototype.onConnected = function ()
	{
		if (mConnectTimeout) {
			clearTimeout(mConnectTimeout);
			mConnectTimeout = null;
		}
		if (mReconnectTimeout) {
			clearTimeout(mReconnectTimeout);
			mReconnectTimeout = null;
		}
		// if enter lobby, start heartbeat for gate server can check & kickout timeout client
		this.startHeartbeat(mHeartbeatData);
		if (onConnected) onConnected();
	}

	CMiddleServer.prototype.onReconnected = function ()
	{
		if (mConnectTimeout) {
			clearTimeout(mConnectTimeout);
			mConnectTimeout = null;
		}
		if (mReconnectTimeout) {
			clearTimeout(mReconnectTimeout);
			mReconnectTimeout = null;
		}
		if (onReconnected) onReconnected();
	}

	CMiddleServer.prototype.onDisconnected = function (errMsg)
	{
		//this.stopHeartbeat();
		if (mReconnectTimeout) {
			clearTimeout(mReconnectTimeout);
			mReconnectTimeout = null;
		}
		if (onDisconnected) onDisconnected(errMsg);
	}

	CMiddleServer.prototype.onConnectionInfo = function (deviceName, connectionId)
	{
		if (deviceName && connectionId) {
			if (!mDeviceName) mDeviceName = deviceName;
			if (!mConnectionId) mConnectionId = connectionId;
			// if found deviceName or connectionId changed, identify self to server
			if (mDeviceName !== deviceName ||
				mConnectionId !== connectionId) {
				oMiddleServer.identifyDevice(mDeviceName, mConnectionId);
			}
			return true;
		}
		return false;
	}

	CMiddleServer.prototype.send = function (cmd, data)
	{
		console.log('CMiddleServer.prototype.Send');
    }

	CMiddleServer.prototype.receive = function (cmd, data)
	{
		if (onReceive) onReceive(cmd, data);
    }

	CMiddleServer.prototype.invoke = function (cmd, data)
	{
		mCmdQueue.push({
			cmd: cmd,
			data: data
		});
	}

	CMiddleServer.prototype.identifyDevice = function (deviceName, connectionId)
	{
		const obj = {
			deviceName: deviceName,
			connectionId: connectionId
		};
		oMiddleServer.invoke(ProtocolCmd.IdentifyDevice, JSON.stringify(obj));
	}

	CMiddleServer.prototype.clrRetryReconnectCntInMachine = function ()
	{
		mRetryReconnectCntInMachine = 0;
	}
}

module.exports = CMiddleServer;